<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver v-slot="{ passed, failed }">
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="EmployeeId"
                      option-value="key"
                      option-text="value"
                      placeholder="الموظف"
                    ></model-list-select>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <model-list-select
                      class="input-must-rtl"
                      :list="deductionTypesModelList"
                      v-model="deductionTypeId"
                      option-value="key"
                      option-text="value"
                      placeholder="نوع المستقطع"
                    ></model-list-select>
                  </div>

                  <div
                    v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-field>
                      <label>المحاكم</label>
                      <md-select v-model="CourtId">
                        <md-option
                          v-for="court in courts"
                          v-bind:key="court.key"
                          :value="court.key"
                          >{{ court.value }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>المرتب الأساسي</label>
                      <md-input disabled v-model="basicSalary"></md-input>
                    </md-field>
                  </div>
                  <div
                    v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>قيمة النفقة</label>
                      <md-input
                        v-model="LegalExpenseValue"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>عدد الأشهر</label>
                      <md-input
                        v-model="Months"
                        type="number"
                        :disabled="isMonthsDisabled"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>المستقطع الكلي</label>
                      <md-input v-model="Value" type="number"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>المستقطع الشهري</label>
                      <md-input
                        disabled
                        :value="monthlyDeduction"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>

                  <!-- <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-datepicker :md-open-on-focus="false" v-model="date">
                      <label class="mr-28">تاريخ بداية الإستقطاع</label>
                    </md-datepicker>
                  </div> -->

                  <!-- <div class="md-layout-item md-size-30 ml-15">
                    <h4 class="">تاريخ بداية الإستقطاع</h4>
                    <month-picker
                      :no-default="true"
                      v-model="date"
                    ></month-picker>
                  </div> -->

                  <div
                    class="md-layout-item md-layout-item-time md-size-30 md-small-size-100 ml-15"
                    style="position: relative"
                  >
                    <h4 class="monthly-picker-head" :class="{ active: date }">
                      تاريخ بداية الاستقطاع
                    </h4>
                    <vue-monthly-picker
                      class="monthly-picker"
                      alignment="right"
                      v-model="date"
                    />
                  </div>

                  <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>ملاحظة</label>
                      <md-input v-model="note"></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-100 mt-25 center-content mnue-employees"
                  >
                    <md-button @click="Save" class="md-success btn_nanosoft"
                      >حفظ</md-button
                    >
                    <md-button @click="clear" class="md-info btn_nanosoft"
                      >جديد</md-button
                    >
                    <md-button @click="Confirm" class="md-success btn_nanosoft"
                      >اعتماد</md-button
                    >
                    <md-button @click="unconfirm" class="md-danger btn_nanosoft"
                      >الغاء الاعتماد</md-button
                    >
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">البحث</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
            >
              <model-list-select
                class="input-must-rtl"
                :list="employees"
                v-model="employeeSearch"
                option-value="key"
                option-text="value"
                placeholder="الموظف"
              ></model-list-select>
            </div>

            <div
              class="md-layout-item md-layout-item-time md-size-30 md-small-size-100 ml-15"
              style="position: relative"
            >
              <h4 class="monthly-picker-head" :class="{ active: dateSearch }">
                تاريخ بداية الاستقطاع
              </h4>
              <vue-monthly-picker
                class="monthly-picker"
                alignment="right"
                v-model="dateSearch"
              />
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 mt-25 center-content">
              <md-button class="md-success btn_nanosoft" @click="onSearchClick"
                >بحث</md-button
              >
            </div>
          </div>

          <div class="md-layout flex-content-left">
            <div class="md-layout-item md-size-15">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <div v-show="tableData.length > 0" class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-checkbox @change="selectAll" v-model="All"
                >اختيار الكل</md-checkbox
              >
            </div>
          </div>

          <md-table
            :value="tableData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell>
                <div class="md-layout-item md-size-20 center-content">
                  <md-checkbox
                    v-model="item.isActive"
                    @change="add(item)"
                  ></md-checkbox>
                </div>
              </md-table-cell>
              <md-table-cell md-label="اسم الموظف">{{
                item.employeeName
              }}</md-table-cell>

              <md-table-cell
                v-if="item.deductionTypeName"
                md-label="نوع المستقطع"
                >{{ item.deductionTypeName }}</md-table-cell
              >

              <md-table-cell
                v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                md-label="المحاكم"
                >{{ item.courtName }}</md-table-cell
              >

              <md-table-cell md-label="تاريخ بداية الاستقطاع">{{
                item.date ? formatMonthYear(item.date) : "-"
              }}</md-table-cell>

              <md-table-cell md-label="المستقطع الكلي">{{
                item.value
              }}</md-table-cell>

              <md-table-cell md-label="المستقطع الشهري">{{
                round(Number(item.monthlyCredit), 3)
              }}</md-table-cell>

              <!-- <md-table-cell md-label="نوع الدفع">شهري</md-table-cell> -->

              <md-table-cell md-label="حالة الاستقطاع">{{
                item.isConfirmed == false ? "غير نشط" : "نشط"
              }}</md-table-cell>

              <!-- <md-table-cell md-label="ملاحظة">{{ item.note }}</md-table-cell> -->

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div> -->
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP.js";
import { Pagination } from "@/components";
import { ModelListSelect } from "vue-search-select";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
// import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import moment from "moment";
import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
extend("required", required);
extend("numeric", numeric);
extend("regex", regex);
extend("confirmed", confirmed);
export default {
  async created() {
    await this.init();
    this.privateCompanyMode = localStorage.getItem("privateCompanyMode");
  },
  components: {
    Pagination,
    ModelListSelect,
    // SlideYDownTransition
  },
  computed: {
    employeesData() {
      return this.$store.getters["global/employeesData"];
    },
    deductionTypesList() {
      const list = this.employeesData && this.employeesData.deductionTypes;
      return Array.isArray(list)
        ? list.map((d) => ({
            id: d.id,
            deductionName: d.deductionName,
            deductionPaymentDuration: d.deductionPaymentDuration,
          }))
        : [];
    },
    deductionTypesModelList() {
      return this.deductionTypesList.map((d) => ({
        key: d.id,
        value: d.deductionName,
      }));
    },
    selectedDeductionType() {
      return (
        this.deductionTypesList.find((d) => d.id === this.deductionTypeId) ||
        null
      );
    },
    monthlyDeduction() {
      const val = Number(this.Value);
      const dur = this.selectedDeductionType?.deductionPaymentDuration;
      if (!isFinite(val)) return 0;
      if (dur === 1 || dur === 3) {
        return this.round(val, 3);
      }
      const months = Number(this.Months);
      if (!isFinite(months) || months <= 0) return 0;
      return this.round(val / months, 3);
    },
    isMonthsDisabled() {
      const dur = this.selectedDeductionType?.deductionPaymentDuration;
      return dur === 1 || dur === 3;
    },
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },
  data() {
    return {
      All: false,
      privateCompanyMode: false,
      errorMessage: "",
      EmployeeSearch: "",
      EmployeeId: "",
      employeeSearch: "",
      dateSearch: null,

      PayType: 0,
      Months: null,
      basicSalary: "",
      Value: null,
      date: "",
      note: null,
      CourtId: null,
      LegalExpenseValue: 0,
      btn: "new",
      idTable: "",
      courts: "",
      deductionValue: "",
      employees: [],
      deductionTypeId: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
      currentSort: "Titel",
      currentSortOrder: "asc",
      tableData: [],
      SelectedEmployees: [],
    };
  },

  watch: {
    deductionTypeId(newValue) {
      console.warn("newValue", newValue);
      console.warn(
        "newValue",
        this.selectedDeductionType.deductionPaymentDuration
      );
      if (this.selectedDeductionType.deductionPaymentDuration === 1) {
        this.Months = 1;
      } else {
        this.Months = null;
      }
    },
    async EmployeeId() {
      try {
        if (!this.EmployeeId) {
          return;
        }
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(
          `${env.HR()}/api/hr/Employees/getBasicSalary/${this.EmployeeId}`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.basicSalary = result.data.data;
      } catch (error) {
        return this.notifyVue("top", "center", "danger", error);
      }
    },
    "pagination.perPage"(newVal) {
      // this.pagination.perPage = newVal;
      this.Search();
    },
    "pagination.currentPage"(newVal) {
      this.Search();
    },

    // pagination: {
    //   handler(newVal) {
    //     this.Search();
    //   },
    //   // deep: true,
    // },
  },

  methods: {
    formatMonthYear(val) {
      if (!val) return "-";
      return moment(val).format("YYYY-MM");
    },
    selectAll(event) {
      if (event) {
        this.SelectedEmployees = this.tableData.map((item) => item.id);
        this.tableData = this.tableData.map((item) => {
          item.isActive = true;
          return item;
        });
      } else {
        this.SelectedEmployees = [];
        this.tableData = this.tableData.map((item) => {
          item.isActive = false;
          return item;
        });
      }
    },
    add(item) {
      // Update the item's isActive state in tableData
      const found = this.tableData.find((i) => i.id === item.id);
      if (found) {
        found.isActive = item.isActive;
      }

      if (item.isActive) {
        if (!this.SelectedEmployees.includes(item.id)) {
          this.SelectedEmployees = [...this.SelectedEmployees, item.id];
        }
        // Check if all items are selected
        if (this.SelectedEmployees.length === this.tableData.length) {
          this.All = true;
        }
      } else {
        this.SelectedEmployees = this.SelectedEmployees.filter((id) => {
          return id != item.id;
        });
        // If any item is deselected, uncheck "Select All"
        this.All = false;
      }
    },
    convert(event) {
      try {
        const currentDate = new Date(event);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        if (isNaN(currentDate.getFullYear()) === true) {
          return "-";
        }
        return formattedDate;
      } catch (error) {}
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    async Search() {
      try {
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        const params = {
          EmployeeId: this.employeeSearch || undefined,
          Date: this.dateSearch ? this.convert(this.dateSearch) : undefined,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        };

        let result = await axios.get(`${env.HR()}/api/Deductions/filter`, {
          params,
          headers: { Authorization: "Bearer " + token },
        });

        this.tableData = result.data.data.results.map((item) => {
          item.isActive = false;
          return item;
        });
        this.pagination.total = result.data.data.total;
        this.SelectedEmployees = [];
        this.All = false;
      } catch (error) {
        return this.message(error);
      }
    },

    onSearchClick() {
      if (this.pagination.currentPage !== 1) {
        // the currentPage watcher runs Search()
        this.pagination.currentPage = 1;
      } else {
        this.Search();
      }
    },

    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let employeeId = localStorage.getItem("idTable");

        if (!this.EmployeeId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار الموظف "
          );
        }

        if (this.selectedDeductionType?.deductionPaymentDuration == 1) {
          if (!this.Months) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال عدد الأشهر "
            );
          }
        }

        if (!this.date) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء إدخال تاريخ بداية الإستقطاع  "
          );
        }

        let token = atob(T);

        let schema = {
          EmployeeId: this.EmployeeId,
          PayType: 0,
          Months: parseInt(this.Months),
          Value: parseFloat(this.Value),
          Date: this.convert(this.date),
          note: this.note ? this.note : null,
          CourtId: this.CourtId ? this.CourtId : null,
          DeductionTypeId: this.deductionTypeId,
          LegalExpenseValue:
            this.LegalExpenseValue === "" ? null : this.LegalExpenseValue,
        };

        if (this.btn === "new") {
          let result = await axios.post(`${env.HR()}/api/Deductions`, schema, {
            headers: { Authorization: "Bearer " + token },
          });
        } else {
          let result = await axios.put(
            `${env.HR()}/api/Deductions/${this.idTable}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        }
        this.btn = "new";
        this.init();
        this.clear();
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        return this.message(error);
      }
    },

    async Confirm() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.patch(
          `${env.HR()}/api/Deductions/confirm`,
          {
            ids: this.SelectedEmployees,
          },
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.notifyVue("top", "center", "success", "تم الاعتماد بنجاح");

        return this.init();
      } catch (error) {
        this.message(error);
      }
    },
    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },

    message(error) {
      const data = error?.response?.data;
      let msg = "";
      if (data && typeof data === "object" && !Array.isArray(data)) {
        if (typeof data.message === "string") {
          msg = data.message;
        } else if (data.errors && typeof data.errors === "object") {
          const key = Object.keys(data.errors)[0];
          const val = data.errors[key];
          msg = Array.isArray(val) ? val.join("\n") : String(val);
        } else {
          const values = Object.values(data).flatMap((v) =>
            Array.isArray(v) ? v : [v]
          );
          msg = values.map((v) => String(v)).join("\n");
        }
      } else {
        msg = (data && String(data)) || error?.message || "";
      }
      this.errorMessage = msg;
      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    async unconfirm() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.patch(
          `${env.HR()}/api/Deductions/unConfirm`,
          {
            ids: this.SelectedEmployees,
          },
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.notifyVue("top", "center", "success", "تم الغاء الإعتماد ");

        return this.init();
      } catch (error) {
        this.message(error);
      }
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(`${env.HR()}/api/Deductions`, {
          headers: { Authorization: "Bearer " + token },
        });
        this.tableData = result.data.data.deductions.results.map((item) => {
          item.isActive = false;
          return item;
        });
        this.pagination.total = result.data.data.deductions.total;
        this.courts = result.data.data.courts;
        this.employees = result.data.data.employees;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },

    clear() {
      // this.EmployeeId = "",
      this.deductionTypeId = "";
      this.Months = null;
      this.Value = "";
      this.date = null;
      this.note = null;
      this.CourtId = null;
      this.LegalExpenseValue = null;
      this.btn = "new";
      this.EmployeeId = "";
      this.basicSalary = "";
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });

      // console.warn("item", item.months);

      this.btn = "Edit";
      this.EmployeeId = item.employeeId;
      this.PayType = item.payType;
      this.Value = item.value;
      this.date = this.convert(item.date);
      this.note = item.note;
      this.CourtId = item.courtId;
      this.LegalExpenseValue = item.legalExpenseValue;
      this.deductionValue = item.monthlyCredit;
      this.idTable = item.id;
      this.deductionTypeId = item.deductionTypeId;

      this.$nextTick(() => {
        this.Months = item.months;
      });
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/Deductions/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            this.init();
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              error.response.data.message
            );
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
};
</script>

<style scoped>
.mt-37 {
  margin-top: 37px;
}

.paginated-table .fullname {
  width: 185px !important;
  display: flex;
  padding-top: 0px !important;
}
</style>
